export const useRuntimeConfig = () => 
window?.__NUXT__?.["search-front"]?.config || window?.useNuxtApp?.("search-front").payload?.config